import CityPageTemplate from "../city-template/CityPageTemplate";
import { bethesdaConfig } from "./data";

export default function BethesdaPage() {
  return <CityPageTemplate config={bethesdaConfig} />;
}